import moment from 'moment';
import { AFFICHAGE, MANUEL } from '@/configuration/logistique/facesDisponible/facesDisponibleConf';
import { LISTE_INDEX_JOURS } from '@/configuration/datePickerConf';
import ucFirst from '@/services/general/ucFirst';

function getListeByListeAffichage(listeTfs) {
  const listFilteredByListeAffichage = [];
  listeTfs.forEach(tfs => {
    if (listFilteredByListeAffichage.find(t => {
      return t.tourneeId === tfs.tourneeId
        && t.tournee === tfs.tournee
      && t.ordreTravailId === tfs.ordreTravailId;
    }) != null) return;
    const tfsParlisteAffichageOt = listeTfs.filter(t => {
      return t.tourneeId === tfs.tourneeId
        && t.tournee === tfs.tournee
      && t.ordreTravailId === tfs.ordreTravailId;
    });
    let tfsIds = [];
    tfsParlisteAffichageOt
      .map((tfsParListe) => tfsParListe.tfs)
      .forEach((tfsListe) => {
        tfsIds = tfsIds.concat(tfsListe.map((tfsInfo) => tfsInfo.id));
      });
    const nbFacesAffichees = tfsParlisteAffichageOt
      .filter(t => t.tfs[0].actionLogistique === AFFICHAGE || t.tfs[0].actionLogistique === MANUEL)
      .length;
    listFilteredByListeAffichage.push({
      dateDepart: tfs.dateDepart,
      libelleJourDepart: ucFirst(LISTE_INDEX_JOURS.find((jour) => {
        return jour.number === moment(tfs.dateDepart).day();
      }).libelle),
      selected: false,
      tournee: tfs.tournee,
      tourneeId: tfs.tourneeId,
      ordreTravailId: tfs.ordreTravailId,
      ordreTravail: {
        code: tfs.ordreTravail?.code,
        etat: tfs?.ordreTravail?.etat,
      },
      nbFaces: nbFacesAffichees,
      nbFacesLp: tfsParlisteAffichageOt.length - nbFacesAffichees,
      ids: tfsIds,
    });
  });
  return listFilteredByListeAffichage.sort((a, b) => {
    if (moment(a.dateDepart).isBefore(moment(b.dateDepart))) return -1;
    return moment(a.dateDepart).isAfter(moment(b.dateDepart)) ? 1 : 0;
  });
}

export default function formatageRessourceByAfficheur(chargeTravail) {
  const ressourceList = [];
  const idsAfficheur = [...new Set(chargeTravail
    .filter(c => !!c.afficheurId)
    .map(c => c.afficheurId))];
  idsAfficheur.forEach(afficheurId => {
    const tfs = chargeTravail.filter(c => c.afficheurId === afficheurId);
    const nbFacesAffichees = tfs
      .filter(t => t.tfs[0].actionLogistique === AFFICHAGE || t.tfs[0].actionLogistique === MANUEL)
      .length;
    ressourceList.push({
      afficheurId: afficheurId,
      afficheur: tfs[0].afficheur,
      nbFaces: nbFacesAffichees,
      nbFacesLp: tfs.length - nbFacesAffichees,
      listeAffichage: getListeByListeAffichage(tfs),
      isOpen: false,
    });
  });
  return ressourceList.sort((a, b) => {
    return a.afficheur.localeCompare(b.afficheur);
  });
}
